import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react';
import { HelperText } from 'react-native-paper';
import { DropDown } from './DropDown/DropDown';
export const ValidatedDropDown = forwardRef(({ testID = 'validated-dropdown', value, rules, errors, hideErrors, onValidate, reValidate, errorsStyle, onChange, onBlur, ...props }, ref) => {
    const [touched, setTouched] = useState(false);
    const hasErrors = useMemo(() => {
        return (errors?.length ?? 0) > 0;
    }, [errors]);
    const validateSelection = (val, touchedOverride = touched) => {
        const validationErrors = [];
        if (touchedOverride) {
            rules?.forEach((rule) => {
                const error = rule(val);
                if (error)
                    validationErrors.push(error);
            });
            if (onValidate) {
                onValidate(validationErrors);
            }
        }
        return validationErrors.length === 0;
    };
    useImperativeHandle(ref, () => ({
        isValid: () => validateSelection(value, true),
    }));
    useEffect(() => {
        if (touched) {
            validateSelection(value);
        }
    }, [value]);
    useEffect(() => {
        if (reValidate) {
            validateSelection(value, true);
        }
    }, [reValidate]);
    const handleChange = (item) => {
        const nextValue = item?.label ?? '';
        validateSelection(nextValue);
        onChange?.(item);
    };
    const handleBlur = (e) => {
        setTouched(true);
        validateSelection(value, true);
        onBlur?.(e);
    };
    return (_jsxs(_Fragment, { children: [_jsx(DropDown, { ...props, testID: testID, value: value, onChange: handleChange, onBlur: handleBlur, error: hasErrors }), !hideErrors &&
                hasErrors &&
                errors?.map((error, index) => (_jsx(HelperText, { testID: `${testID}-error-${index}`, type: 'error', style: errorsStyle, children: error }, `error-${index}`)))] }));
});
